const openAiAllowedAccountIDs = {
  1: true,
  55: true,
  56: true,
  65: true,
  81: true,
  92: true,
  79: true,
  82: true,
  83: true,
  94: true,
  69: true,
  97: true,
  104: true,
  111: true,
  113: true,
}

export default openAiAllowedAccountIDs
